import { render, staticRenderFns } from "./LotTemplateList.vue?vue&type=template&id=85c8a066&v-slot%3AtabItem=%7B%20current%20%7D&"
import script from "./LotTemplateList.vue?vue&type=script&lang=js&"
export * from "./LotTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports